import { reduce, get, isArray } from 'lodash';

const bilanChartMixin = {
    props: {
        data: Object,
        height: Number,
    },

    data()
    {
        return {
            isOpened: false,
        };
    },

    computed: {
        total()
        {
            return reduce(this.data, (carry, item) => {
                carry += get(item, 'total', 0);
                return carry;
            }, 0);
        },

        chartSize()
        {
            return `${this.height}px`;
        },

        chartStyle()
        {
            const padded = this.height + 60;
            return `width: ${padded}px; height: ${padded}px;`;
        },

        dataStyle()
        {
            const padded = this.height + 60;
            return `height: ${padded}px;`;
        },

        scrollStyle()
        {
            const padded = this.height - 25;
            return `height: ${padded}px;`;
        },

        detailTitle()
        {
            if (isArray(this.isOpened))
            {
                const number = get(this.isOpened[0], 'total', 0);
                const label = this.isOpened[1];
                return  `<strong class="s-bleu">${number}</strong> ${label}`
            }
            const padded = this.height + 60;
            return `height: ${padded}px;`;
        },
    },

    methods: {
        calcPercent(value)
        {
            if (this.total > 0)
            {
                return Math.round((value.total * 1000) / this.total) / 10;
            }
            return 0;
        },

        openDetails(data, label)
        {
            this.isOpened = [data, label]
        },

        closeDetails()
        {
            this.isOpened = false
        },

        makeTooltip(value)
        {
            if (value.total === 1) {
                return `Voir la municipalité`
            }
            return `Voir les ${value.total} municipalités`
        }
    },

};

export { bilanChartMixin }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vue/mixins/bilan-chart-mixin.js